import React from "react";

const ArrowLeft = ({ ...rest }) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="arrow-left">
                <path
                    id="Icon"
                    d="M13.1666 8.81639H3.83325M3.83325 8.81639L8.49992 13.4831M3.83325 8.81639L8.49992 4.14972"
                    stroke="currentColor"
                    strokeWidth="1.33"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default ArrowLeft;
